import { colors } from '@/styles'

const defaultBaseColor = '#eee'
const defaultHighlightColor = colors.grey96

const scale = 1.725
const endScale = 0.8625

const shimmer = (w: number, h: number) => `
<svg width="${w}" height="${h}" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
  <defs>
    <linearGradient id="g">
      <stop stop-color="${defaultBaseColor}" offset="0%" />
      <stop stop-color="${defaultHighlightColor}" offset="25%" />
      <stop stop-color="${defaultBaseColor}" offset="100%" />
    </linearGradient>
  </defs>
  <symbol id="l" viewBox="0 0 37 52" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M23.172 25.677L20.5 27.79v3.358h5.344V27.79z" fill="#fff"></path><path d="M15.297 31.129h5.273V15.73h-5.273z" fill="#fff"></path><path d="M20.57 27.63l-.003 3.499h-5.27z" fill="#eee"></path></g></symbol>
  <rect width="${w}" height="${h}" fill="${defaultBaseColor}" />
  <rect id="r" width="${w / scale}" height="${h}" fill="url(#g)" />
  <use href="#l" height="101px" width="72px" x="50%" y="50%" transform="translate(-36,-50.5)" />
  <animate xlink:href="#r" attributeName="x" from="-${w / scale}" to="${
  w / endScale
}" dur="1.2s" repeatCount="indefinite"
calcMode="spline" keySplines="0.42,0,0.58,1" />
</svg>`

const toBase64 = (str: string) =>
  typeof window === 'undefined'
    ? Buffer.from(str).toString('base64')
    : window.btoa(str)

const shimmerImage = (w: number, h: number) =>
  `data:image/svg+xml;base64,${toBase64(shimmer(w, h))}`

export default shimmerImage
